import { render, staticRenderFns } from "./xmind.vue?vue&type=template&id=b526aa9a&"
import script from "./xmind.vue?vue&type=script&lang=js&"
export * from "./xmind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports